// Packages
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Components
import Container from 'components/BTDUI/Container';
import Header from 'components/Header';
import Footer from 'components/Footer';

const ProcedureViewLayout = ({ children }) => {

	return (
		<div className='ProcedureViewLayout'>
			
			<Header/>

			<Container>

				<Link className='blue opacity' to='/procedures'>Procedures {'>'}</Link> 

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

ProcedureViewLayout.propTypes = {
	children: PropTypes.node,
}

ProcedureViewLayout.defaultProps = {
	children: null,
}

export default ProcedureViewLayout;